import React from "react";
import { makeStyles, createStyles, Theme } from "@material-ui/core/styles";
import { IWidget } from "apiConsumers/newsApiConsumer/models/INewsArticle";
import ContentResolver from "./articleContentResolver/ContentResolver";

const useStyles = makeStyles((theme: Theme) => {
    return createStyles({
        root: {
            display: "flex",
            flexDirection: "column",
            "& p": {
                margin: 0,
            },
            "& a": {
                color: theme.palette.primary.main,
            },
        },
    });
});
interface IProps {
    articleContent: IWidget[];
}

export default function ArticleContent(props: IProps) {
    const { articleContent } = props;
    const classes = useStyles();

    return (
        <div className={classes.root}>
            {articleContent.map((content, i) => (
                <React.Fragment key={i}>
                    <ContentResolver content={content} />
                </React.Fragment>
            ))}
        </div>
    );
}
